import $ from 'jquery'
import Swiper from './utils/getSwiper'

function init () {
  $('.tab-text-image-module').each(function () {
    initSlider($(this))
  })
}

function initSlider (container) {
  const controlButtons = !!(container.data('button-control'))

  let nav = container.find('.tab-swiper-js').first(),
    images = container.find('.image-swiper-js').first(),
    imagesSlider

  let navSlider = new Swiper(nav.get(0), {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 300,
    watchSlidesProgress: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchOverflow: true,
    breakpoints: {
      // when window width is <= 992px md
      992: {
        allowTouchMove: true
      },
      // when window width is <= 768px sm
      768: {
        allowTouchMove: true,
        // centeredSlides: true,
        slideToClickedSlide: true
      },
      576: {
        allowTouchMove: true,
        centeredSlides: true,
        slideToClickedSlide: true
      }
    },
    on: {
      slideChange: function () {
        setTimeout(function () {
          setMobileActive()
        }, 300)
      }
    }
  })

  imageSwiper()

  $(window).on('resizeend', function () {
    var currentSlide = imagesSlider.activeIndex

    imagesSlider.destroy(false, true)
    imageSwiper(currentSlide)
  })

  function imageSwiper (activeIndex) {
    if (!activeIndex) {
      activeIndex = 0
    }
    imagesSlider = new Swiper(images.get(0), {
      slidesPerView: '1',
      initialSlide: activeIndex,
      centeredSlides: true,
      preloadImages: false,
      fadeEffect: {
        crossFade: true
      },
      speed: 0,
      effect: 'fade',
      allowTouchMove: false,
      autoScaleSlider: true,
      watchSlidesVisibility: true
    })

    if (controlButtons) {
      let testImages = images.find('.text-image')
      testImages.each(function (index, elem) {
        if (testImages.length - 1 > index) {
          let button = $(elem).find('.btn').first()

          if (button.length > 0) {
            button.off('click')
            button.on('click', function (event) {
              event.preventDefault()
              nav.find(`[data-swiper-index=${imagesSlider.activeIndex + 1}]`).click()
            })
          }
        }
      })
    }
  }

  nav.find('.swiper-slide').each(function () {
    $(this).on('click', function () {
      let index = $(this).data('swiper-index')
      nav.find('.swiper-slide').removeClass('active')
      $(this).addClass('active')
      imagesSlider.slideTo(index)
      if ($(window).width() > 576) {
        navSlider.slideTo(index)
      }
    })
  })

  function setMobileActive (direction) {
    if ($(window).width() <= 576) {
      let index = nav.find('.swiper-slide-active').data('swiper-index')
      nav.find('.swiper-slide').removeClass('active')
      nav.find('.swiper-slide-active').addClass('active')
      imagesSlider.slideTo(index)
    }
  }
}

export default {
  init
}
